import { get } from "lodash"
// @ts-ignore
import Papa from "papaparse"

import { CalculationDataTypeValue, CaseDetails, Team } from "../types"

import { calculatedValueDisplay } from "../mixins/calculatedValueDisplay"
import { formatDateMixin } from "../mixins/formatDateMixin"
import { CaseColumn } from "@/types/caseColumns"

import dataTypeFunctions from "./dataTypeFunctions"

import sanitizeHtml from "sanitize-html"

export const csvExport = {
	// If a value of a field is an object type, return a string value of that object
	objectToString (object: any) {
		if (object == null || object === undefined) return ""

		try {
			if (typeof (object) === "object") {
				return JSON.stringify(object)
			} else {
				return object
			}
		} catch (err) {
			return object
		}
	},

	fieldLabel (column: CaseColumn, value: any, label: string | null, record: CaseDetails) {
		if (column.dataType === "user" || column.dataType === "user-picture") {
			const usersName = record.users!.find((u: { id: string }) => u.id === value)
			return usersName ? usersName.name : this.objectToString(value)
		}

		if (column.dataType === "calculated") {
			return calculatedValueDisplay.methods.displayCalculatedField(
				record as CaseDetails,
				column.fieldExtensions,
				value,
				true)
		}

		if (column.fieldDataType && dataTypeFunctions[column.fieldDataType] && dataTypeFunctions[column.fieldDataType]!.toCsvString) {
			return dataTypeFunctions[column.fieldDataType]!.toCsvString!(column, value, label, record)
		}

		return label || this.objectToString(value)
	},

	// Converts the results into a downloaded-able CSV
	resultsToCsv (columns: CaseColumn[], resultGroups: any[], preventSanitizationOfRichText: boolean = false) {
		let filteredArray: any[] = []
		const isGrouped = resultGroups.length > 1

		const csvHeader: any = columns.reduce((obj: { [key: string]: string }, column) => {
			obj[column.key] = column.label
			return obj
		}, {})

		if (isGrouped) {
			csvHeader["GroupBy"] = "Group By"
		}

		if (resultGroups) {
			resultGroups.forEach(resultGroup => {
				if (!resultGroup.results) { return }
				let mappedResult: any[] = resultGroup.results.map(
					(record: any) => {
						let mappedRecord = columns
							.reduce((obj: any, column) => {
								let value = get(record, column.key)
								if (value !== undefined) {
									let label: string | null = null
									if (column.dynamicField) {
										label = value.label
										value = value.value
									} else if (column.displayKey) {
										label = get(record, column.displayKey)
									}

									if (column.fieldExtensions?.allowRichText && !preventSanitizationOfRichText) {
										value = sanitizeHtml(value, {
											allowedTags: [],
											allowedAttributes: {}
										})
									}

									obj[column.key] = this.fieldLabel(
										column,
										value,
										label,
										record)
								}

								return obj
							}, {})

						if (isGrouped) {
							mappedRecord["GroupBy"] = resultGroup.label ? resultGroup.label : "None"
						}
						return mappedRecord
					})

				if (!filteredArray) {
					filteredArray = mappedResult
				} else {
					filteredArray = filteredArray.concat(mappedResult)
				}
			})
		}
		filteredArray.unshift(csvHeader)

		return Papa.unparse(filteredArray, { delimiter: ",", header: false, escapeFormulae: true })
	}
}
